import gql from "graphql-tag";

export const LOGIN = gql`
  mutation login(
    $email: String!
    $password: String!
    $full_name: String
    $role: USER_ROLES
  ) {
    userLogin(
      input: {
        email: $email
        password: $password
        full_name: $full_name
        role: $role
      }
    ) {
      accessToken
      refreshToken
      data {
        userId
        profileId
        is_profile_setup
        role
        term_and_conditions
      }
    }
  }
`;
